var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7365 22.6249C8.37267 24.5187 4.19077 25.4639 3.19459 28.6633C2.20182 31.8593 5.05095 35.1947 10.7526 41.8621L12.2282 43.5859C13.8465 45.4797 14.6591 46.4283 15.0229 47.5979C15.3867 48.7709 15.2643 50.0357 15.0195 52.5619L14.7951 54.8638C13.9349 63.7616 13.5032 68.2088 16.1075 70.1842C18.7118 72.163 22.6285 70.3576 30.4552 66.7536L32.4849 65.822C34.7085 64.7952 35.8202 64.2852 37 64.2852C38.1798 64.2852 39.2915 64.7952 41.5185 65.822L43.5414 66.7536C51.3715 70.3576 55.2882 72.1596 57.8891 70.1876C60.4968 68.2088 60.0651 63.7616 59.2049 54.8638M63.2474 41.8621C68.949 35.1981 71.7982 31.8627 70.8054 28.6633C69.8092 25.4639 65.6273 24.5153 57.2635 22.6249L55.1012 22.1353C52.7246 21.5981 51.5381 21.3295 50.5827 20.6053C49.6307 19.8811 49.0187 18.7828 47.7947 16.5864L46.6796 14.5872C42.3719 6.86241 40.2197 3 37 3C33.7803 3 31.6281 6.86241 27.3204 14.5872",
    stroke: "#FE8F01",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5831f8957c4d3cca2cd1ea1e81c5aefc.svg";
export { ForwardRef as ReactComponent };